import { PortfolioStats, SanityGlobalSocialStats, SanitySocialStatsResponse } from 'types/sanity/marketing-components';
import { apiRequest } from '@utils/request';
import { GlobalSocialStats as SocialStats } from '@sanity/graphql/queries/global-social-stats';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getSocialStats(): Promise<SanityGlobalSocialStats | null> {
	const { data } = await useQuery<SanitySocialStatsResponse>({
		client: villusClient,
		query: SocialStats
	}).execute();

	return data?.allGlobalSocialStats[0] ?? null;
}

export async function getPortfolioStats(): Promise<PortfolioStats> {
	let sanityStatsResponse: SanityGlobalSocialStats | undefined = undefined;

	const reitElementStrategyTotalsUrl = apiRequest.get(`/reit-elements/strategy-totals`);

	const reitsTotalsResponse = await reitElementStrategyTotalsUrl;

	const { data } = await useQuery<SanitySocialStatsResponse>({
		client: villusClient,
		query: SocialStats
	}).execute();

	sanityStatsResponse = data?.allGlobalSocialStats[0] ?? undefined;

	return {
		sanityStats: sanityStatsResponse,
		reitsTotals: reitsTotalsResponse.data
	};
}
